import random from 'lodash/random';

export function generateRandomPhoneNumber(): string {
  // NOTE: adheres to the accepted phone Regexp from `domains/website/website/src/validation/patterns.ts`
  const areaCode = `${random(2, 9)}${random(0, 8)}${random(0, 9)}`;
  const centralOfficeCode = `${random(2, 9)}${random(0, 9)}${random(0, 9)}`;
  const lineNumber = `${random(0, 9)}${random(0, 9)}${random(0, 9)}${random(0, 9)}`;

  return `${areaCode}-${centralOfficeCode}-${lineNumber}`;
}
